"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionName = void 0;
exports.CollectionName = {
    Bookings: 'ThreePartyBookings',
    Attendees: 'Attendees',
    AttendeeEmails: 'AttendeeEmails',
    Actions: 'Actions',
    CandidatePeriods: 'CandidatePeriods',
    AttendeesAtAction: 'AttendeesAtAction'
};
//# sourceMappingURL=collectionName.js.map